<div class="Cookie-Policy p-4" *ngIf="currentLange === 'fr'; else en">

  <!-- COOKIE POLICY -->
  <p class="mt-2 text-xs font-medium">
    Charte de gestion des cookies | CLS.COM
  </p>
  <ul class="mt-2 text-xxs">
    <li><u>Article 1 - Préambule</u></li>
    <li><u>Article 2 - Qui collecte mes données ?</u></li>
    <li><u>Article 3 - Qu'est-ce qu'un cookie ?</u></li>
    <li><u>Article 4 - A quoi servent les cookies ?</u></li>
    <li><u>Article 5 - Les cookies du site et leur finalité</u></li>
    <li><u>Article 6 - Installer ces cookies, c'est votre choix</u></li>
    <li><u>Article 7 - Votre consentement</u></li>
    <li><u>Article 8 - Vos droits d'accès, de suppression, d'opposition</u></li>
    <li><u>Article 9 - Durée de conservation</u></li>
  </ul>

  <p class="mt-2 text-xxs underline">Article 1 : Préambule</p>
  <p class="mt-2 text-xxs">
    La présente Charte de gestion des Cookies s'adresse aux utilisateurs du présent site internet édité par CLS - SKI COMPANY www.passfeet.com, , (ci-après le « SITE »), à savoir, toute personne qui accède et navigue sur le SITE, et notamment les membres inscrits sur le SITE ou les internautes visiteurs.
    En navigant sur le SITE, vous consentez à ce que les cookies tels que décrits ci-dessous puissent être placés sur votre terminal conformément à la présente Charte de gestion des Cookies.
  </p>
  <p class="mt-2 text-xxs underline">Article 2 : Qui collecte mes données ?</p>
  <p class="mt-2 text-xxs">
    Le responsable des traitements des données des Utilisateurs collectées via le SITE est la Société « CLS - SKI COMPANY », SAS au capital de 1.257.322 euros sise 424 Bureaux de la Colline - 92213 ST-CLOUD CEDEX (ci-après « CLS»).
  </p>
  <p class="mt-2 text-xxs underline">Article 3 : Qu'est-ce qu'un cookie ?</p>
  <p class="mt-2 text-xxs">
    Un cookie est un fichier texte déposé sur le disque dur de votre terminal lors de votre visite sur un site internet. Il enregistre certaines informations sur votre navigation ou sur votre comportement en ligne qui nous permettent d'améliorer et de faciliter votre expérience en qualité d'internaute.
  </p>
  <p class="mt-2 text-xxs underline">Article 4 : A quoi servent les cookies ?</p>
  <p class="mt-2 text-xxs">
    Le SITE utilise des cookies afin de différencier les internautes pour améliorer leur navigation et les services qui leur sont proposés. En pratique, les cookies permettent ainsi de vous authentifier et de vous identifier, ils peuvent, le cas échéant, enregistrer vos préférences ou mesurer les différents usages du SITE.
  </p>
  <p class="mt-2 text-xxs underline">Article 5 : Les cookies du site et leur finalité</p>
  <p class="mt-2 text-xxs">
    CLS privilégie la transparence dans le traitement de vos données. A ce titre et pour que votre information soit la plus claire possible, vous trouverez ci-dessous différents cookies utilisés sur le SITE et leur finalité :
  </p>
  <p class="mt-2 text-xxs underline">5.1. Les cookies CLS (cookies propriétaires)</p>
  <p class="mt-2 text-xxs">
    5.1.1. Les cookies fonctionnels et techniques permettant majoritairement d'améliorer votre navigation sur le SITE<br /><br />
    Ce sont eux qui vont envoyer des informations à notre site et à votre navigateur : mémorisation des informations relatives à un formulaire (identifiant, adresse), les préférences d'affichage de votre terminal (langue, résolution), des mesures de sécurité comme l'expiration de votre session etc.<br /><br />
    <b>ATTENTION</b>, la navigation sur le SITE et/ou l'utilisation de certaines fonctionnalités pourraient être altérées si vous choisissez de désactiver ces cookies.
  </p>

  <table class="mt-2 text-xxs">
    <thead>
    <tr>
      <td><b>Nom du cookie</b></td>
      <td><b>Finalité du cookie</b></td>
    </tr>
    </thead>
    <tr>
      <td>didomi_token</td>
      <td>Ce cookie permet au www.passfeet.com de savoir si votre navigateur accepte ou non les cookies.</td>
    </tr>
    <tr>
      <td>euconsent-v2</td>
      <td>Ce cookie contient votre consentement ou non du dépôt de cookie sur www.passfeet.com</td>
    </tr>
    <tr>
      <td>MyPassfeet-default-lang</td>
      <td>Ce cookie permet à www.passfeet.com de retenir votre langue sélectionnée par défaut</td>
    </tr>
  </table>

  <p class="mt-2 text-xxs underline">Article 6 : Installer ces cookies, c'est votre choix</p>
  <p class="mt-2 text-xxs">
    Sur vos ordinateurs, Smartphones et autres terminaux d'accès à Internet, par défaut le logiciel de navigation accepte les cookies présents sur les sites internet. <br /><br >
    Mais vous restez maître de l'installation de ces cookies car vous avez la possibilité de configurer votre logiciel de navigation pour : <br /><br />
  </p>

  <ul class="mt-2 text-xxs">
    <li>Accepter ou refuser les cookies se trouvant sur le SITE;</li>
    <li>Refuser systématiquement tous les cookies;</li>
    <li>Demander votre consentement sur chacun des cookies que vous rencontrez lors de votre navigation sur internet.</li>
  </ul>

  <p class="mt-2 text-xxs">
    Pour ce faire, il vous suffit de vous reporter à vos logiciels de navigation et de suivre leurs instructions. A titre d'exemple : <br /> <br />
  </p>

  <ul class="mt-2 text-xxs">
    <li>Avec Internet Explorer : menu Outils ► Options► onglet Vie Privée ► choisissez les options souhaitées.</li>
    <li>Avec Firefox : menu Outils ► Options ► onglet Vie privée ► choisissez les options souhaitées.</li>
    <li>Avec Chrome : menu configuration (logo paramètres) ► Paramètres ► Paramètres avancés ► Paramètres de contenu ► choisissez les options souhaitées.</li>
    <li>Avec Safari : Safari (logo paramètres) ► Préférences ► Sécurité ► Afficher les cookies ► choisissez les options souhaitées.</li>
    <li>Avec Opéra : menu Outils ► Préférences ► Onglet Avancé ► Rubrique Cookies ► Gérer les cookies ► choisissez les options souhaitées.</li>
  </ul>

  <p class="mt-2 text-xxs">
    <b>IMPORTANT !</b> Comme indiqué précédemment, en choisissant de bloquer nos cookies, nous tenons à vous informer que la navigation sur le SITE et/ou l'utilisation de certaines fonctionnalités pourraient être altérées.
    En tout état de cause, si vous choisissez de supprimer tous les cookies, votre expérience utilisateur en sera fortement affectée et vos préférences de navigation seront effacées.
  </p>
  <p class="mt-2 text-xxs font-medium">
    Article 7 : Votre consentement
  </p>
  <p class="mt-2 text-xxs">
    En navigant sur le SITE, vous acceptez que CLS installe des cookies dits « techniques » qui accèdent, inscrivent et consultent des informations stockées dans votre équipement terminal :
  </p>

  <ul class="mt-2 text-xxs">
    <li>Ayant pour finalité exclusive de permettre ou faciliter la communication par voie électronique</li>
    <li>Strictement nécessaires à la fourniture du service de communication en ligne du SITE.</li>
  </ul>

  <p class="mt-2 text-xxs">
    Lors de votre inscription sur le SITE, vous avez également été informés de la présence de cookies traceurs destinés notamment à vous proposer des offres adaptées à vos centres d'intérêts et à réaliser des statistiques de visites et de la possibilité de vous y opposer en accédant à la présente Charte de gestion des cookies.
  </p>
  <p class="mt-2 text-xxs underline">Article 8 : Vos droits d'accès, de suppression, d'opposition</p>
  <p class="mt-2 text-xxs">
    Comme pour les autres données, vous pouvez exercer vos droits d'accès, de suppression et d'opposition sur vos données en faisant la demande par e-mail à l'adresse privacy&#64;passfeet.com ou par courrier papier à l'adresse du siège social de la Société CLS SKI COMPANY en indiquant dans l'objet « Informatique et libertés » et en justifiant de votre identité.<br />
    En outre, si votre navigateur internet le permet, vous pouvez à tout moment désactiver ces cookies en vous référant aux procédures détaillées ci-avant.
  </p>
  <p class="mt-2 text-xxs underline">Article 9 : Durée de conservation</p>
  <p class="mt-2 text-xxs">
    En tout état de cause, les cookies stockés dans votre terminal auront une durée de vie limitée à 6 mois maximum, cette durée n'étant pas prorogée automatiquement lors de vos nouvelles visites sur le SITE.
  </p>

</div>

<ng-template #en>
  <div class="Cookie-Policy p-4">

    <p class="mt-2 text-xs font-medium">
      Cookie Management Charter | PASSFEET.COM
    </p>
    <ul class="mt-2 text-xxs">
      <li><u>Article 1 - Preamble</u></li>
      <li><u>Article 2 - Who collects my data?</u></li>
      <li><u>Article 3 - What is a cookie?</u></li>
      <li><u>Article 4 - What are cookies used for?</u></li>
      <li><u>Article 5 - The site's cookies and their purpose</u></li>
      <li><u>Article 6 - Cookie settings are your choice</u></li>
      <li><u>Article 7 - Your consent.</u></li>
      <li><u>Article 8 - Your rights of access, deletion, objection.</u></li>
      <li><u>Article 9 - Conservation period</u></li>
    </ul>

    <p class="mt-2 text-xxs underline">Article 1 : Preamble</p>
    <p class="mt-2 text-xxs">
      This Cookies Management Charter is intended for users of this website published by CLS - SKI COMPANY www.skiset.com, (hereinafter the "SITE"), i.e. any person accessing and browsing the SITE, and in particular members registered on the SITE or visiting Internet users.
      By browsing the SITE, you agree that the cookies, as described below, may be placed on your device in accordance with this Cookies Management Charter.
    </p>
    <p class="mt-2 text-xxs underline">Article 2 : Who collects my data?</p>
    <p class="mt-2 text-xxs">
      The company responsible for processing the data collected from the User via the WEBSITE is "CLS - SKI COMPANY", an SAS with capital of 1,257,322 euros with office at 424 Bureaux de la Colline - 92213 ST-CLOUD CEDEX (hereinafter referred to as "PASSFEET").
    </p>
    <p class="mt-2 text-xxs underline">Article 3 : What is a cookie?</p>
    <p class="mt-2 text-xxs">
      A cookie is a text file placed on your device's drive when you visit a website. It records certain information about your browsing and online behaviour, enabling us to improve and facilitate your experience as a web surfer.
    </p>
    <p class="mt-2 text-xxs underline">Article 4 : What are cookies used for?</p>
    <p class="mt-2 text-xxs">
      The SITE uses cookies to differentiate between Internet users in order to improve their browsing experience and the services offered to them. In practice, cookies enable you to be authenticated and identified, and may, where appropriate, record your preferences or measure your different uses of the SITE
    </p>
    <p class="mt-2 text-xxs underline">Article 5 : The site's cookies and their purpose</p>
    <p class="mt-2 text-xxs">
      PASSFEET aims at transparency in the processing of your data. In order to provide you with the clearest possible information, you will find below the different cookies used on the SITE and their purpose:</p>
    <p class="mt-2 text-xxs underline">5.1. PASSFEET cookies (proprietary cookies)</p>
    <p class="mt-2 text-xxs">
      5.1.1. Functional and technical cookies are mainly used to improve your browsing experience on the WEBSITE.<br /><br />
      These are used to send information to our site and to your browser, including storage of information relating to a form (identifier, address), your device's display preferences (language, resolution), security measures such as session expiry, etc.<br /><br />
      <b>WARNING</b>, browsing the SITE and/or using certain functionalities could be altered if you choose to disable these cookies.
    </p>

    <table class="mt-2 text-xxs">
      <thead>
      <tr>
        <td><b>Cookie name</b></td>
        <td><b>Purpose of the cookie</b></td>
      </tr>
      </thead>
      <tr>
        <td>didomi_token</td>
        <td>This cookie enables the SITE to know whether your browser accepts cookies.</td>
      </tr>
      <tr>
        <td>euconsent-v2</td>
        <td>This cookie allows you to return to the page you previously consulted on the SITE.</td>
      </tr>
      <tr>
        <td>MyPassfeet-default-lang</td>
        <td>This cookie enables the SITE to retain your selected language, at your request.</td>
      </tr>
    </table>

    <p class="mt-2 text-xxs underline">Article 6 : Cookie settings are your choice</p>
    <p class="mt-2 text-xxs">
      On your computers, smartphones and other Internet access devices, your browser software accepts cookies from websites by default. <br /><br >
      However, you remain in control of the installation of these cookies, as you can configure your browser to:<br /><br />
    </p>

    <ul class="mt-2 text-xxs">
      <li>Accept or refuse cookies on the SITE;</li>
      <li>Systematically refuse all cookies;</li>
      <li>Ask for your consent for each cookie you encounter while browsing the Internet.</li>
    </ul>

    <p class="mt-2 text-xxs">
      To do this, simply refer to your browsers and follow their instructions. For example: <br /> <br />
    </p>

    <ul class="mt-2 text-xxs">
      <li>With Internet Explorer: Menu Tools ► Options ► Privacy tab ► choose the desired options.</li>
      <li>With Firefox: Menu Tools ► Options ► Privacy tab ► choose the desired options.</li>
      <li>With Chrome: configuration menu (settings logo) ► Parameters ► Advanced settings ► Content settings ► choose the desired options.</li>
      <li>With Safari: Safari (settings logo) ► Preferences ► Security ► Show cookies ► choose the desired options.</li>
      <li>With Opera: Menu Tools ► Preferences ► Advanced tab ► Cookies heading ► Manage cookies ► choose the desired options.</li>
    </ul>

    <p class="mt-2 text-xxs">
      <b>IMPORTANT!</b> As mentioned above, if you choose to block our cookies, please be informed that browsing the SITE and/or the use of certain functions may be altered.
      In any case, if you choose to delete all cookies, your user experience will be greatly affected and your browsing preferences will be erased.
    </p>
    <p class="mt-2 text-xxs font-medium">
      Article 7 : Your consent
    </p>
    <p class="mt-2 text-xxs">
      By browsing the SITE, you accept that PASSFEET installs so-called "technical" cookies which access, record and consult information stored in your device:
    </p>

    <ul class="mt-2 text-xxs">
      <li>The sole purpose of which is to enable or facilitate communication by electronic means;</li>
      <li>Is strictly necessary for the provision of the SITE's online communication service.</li>
    </ul>

    <p class="mt-2 text-xxs">
      When you registered on the SITE, you were also informed of the presence of tracking cookies intended in particular to provide you with offers tailored to your interests and to compile visit statistics, and of your option to refuse them by accessing this Cookie Management Charter.
    </p>
    <p class="mt-2 text-xxs underline">Article 8: Your rights of access, deletion, objection</p>
    <p class="mt-2 text-xxs">
      As with other data, you may exercise your rights to access, delete and object to your data by sending an e-mail request to privacy&#64;passfeet.com or by post to the CLS SKI COMPANY head office address, indicating "Data processing and freedoms" in the subject line and providing proof of your identity.
      In addition, if your browser permits, you can deactivate these cookies at any time by referring to the procedures detailed above.
    </p>
    <p class="mt-2 text-xxs underline">Article 9 : Conservation period</p>
    <p class="mt-2 text-xxs">
      In any event, the cookies stored on your terminal will have a life limited to a maximum of 6 months, and this period will not be automatically extended when you visit the SITE again.
    </p>

  </div>
</ng-template>
